import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import '../../common/rsuite-datepicker.css';
import Select, { StylesConfig, components } from 'react-select';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
    updateTimesheetApprovalStatusId, updateTimesheetEnteredTypeId, updateIncludePeriodListDateRange, updateTimesheetPeriodListEmpId, updateTimesheetFilterDates,
    getTimeEntryPeriodListAsync,getEmployeeAsync
} from './timesheetSlice';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, dateFormatByAccountCultureForFilters } from '../../common/timeLiveFunction';
import { getValueFromResource } from '../../common/timeLiveFunction';
import DatePickerRanges from '../../common/DatePickerRanges';
const TimesheetPeriodFilters = (props: any) => {
    const dispatch = useAppDispatch();
    const [startDate, setStartDate] = useState(new Date());
    const { t } = useTranslation();
    const [endDate, setEndDate] = useState(new Date());
    const [employeeArray, setEmployeeArray] = useState<any | ''>([]);
    const [isSearchable, setIsSearchable] = useState(true);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const [employeeName, setEmployeeName] = useState<String | ''>('');
    const { employeeList, accountEmployeeId, timesheetApprovalStatusList, timesheetEnteredList, timesheetApprovalStatusId, timesheetEnteredTypeId,
        includeDateRangePeriodList } = useAppSelector((state) => state.timesheet);
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat,sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    let getEmployeeName = '';
    let array: any[] = [];
    useEffect(() => {
    dispatch(getEmployeeAsync());
}, [dispatch]);

    useEffect(() => {
    if (employeeList && employeeList.length > 0) {
        let array: any[] = [];

        // 1. Saare employees ko list/options mein convert karein
        employeeList.forEach(item => {
            if (item) {
                array.push({ value: item.AccountEmployeeId, label: item.EmployeeName });
            }
        });
        setEmployeeArray(array);
        const activeId :any = accountEmployeeId || sessionAccountEmployeeId; 
        const EmployeeId :any = sessionAccountEmployeeId;
        const matchedOptions = array.filter(x => Number(x.value) === Number(activeId));
        if (matchedOptions.length > 0) {
            setSelectedOption(matchedOptions);
            setEmployeeName(matchedOptions[0].label);            
            if (!accountEmployeeId && activeId) {               
                dispatch(updateTimesheetPeriodListEmpId(activeId.toString()));
            }
        }        
        else if (array.length > 0) {
            setSelectedOption([array[0]]);
            setEmployeeName(array[0].label);           
        }
    }

}, [employeeList, accountEmployeeId, sessionAccountEmployeeId, dispatch]);


const onDropDownChange = (data: any, isDropDown: number) => {
    if (isDropDown == 1) {
        dispatch(updateTimesheetApprovalStatusId(data.value));
    } else if (isDropDown == 2) {
        dispatch(updateTimesheetEnteredTypeId(data.value));
    } else if (isDropDown == 3) {
        setSelectedOption(data);
        const values = data ? data.map((option: any) => option.value) : []; 
        
        dispatch(updateTimesheetPeriodListEmpId(values.toString()));
    }
}
    // employeeList.map(item => {
    //     array.push({ value: item.AccountEmployeeId, label: item.EmployeeName })
    //     if (item != undefined && Number(item.AccountEmployeeId) == accountEmployeeId) {
    //         getEmployeeName = item.EmployeeName;
    //     }
    // });

    // if (getEmployeeName != employeeName && getEmployeeName != undefined) {
    //     setEmployeeName(getEmployeeName);
    //     if (array[0] != undefined) {
    //         setSelectedOption(array.filter(x => x.value == accountEmployeeId)[0]);
    //     }
    //     setEmployeeArray(array);
    // }

    // const onDropDownChange = (data: any, isDropDown: number) => {
    //     if (isDropDown == 1) {
    //         dispatch(updateTimesheetApprovalStatusId(data.value));
    //     } else if (isDropDown == 2) {
    //         dispatch(updateTimesheetEnteredTypeId(data.value));
    //     } else if (isDropDown == 3) {
    //         setSelectedOption(data);
    //         const values = data.map((option: any) => option.value);
    //         dispatch(updateTimesheetPeriodListEmpId(values.toString()));
    //     }
    // }

    const handleIncludeDateRange = (e: any) => {
        const { checked } = e.target;
        // dispatch(updateIncludeDateRange(checked));
        dispatch(updateIncludePeriodListDateRange(checked));
    }

    const handleDateRangeChange = (value: any) => {
        // setStartDate(value[0]);
        // setEndDate(value[1]);
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(updateTimesheetFilterDates({ "startDate": moment(value[0]).format(dateInsertionFormat), "endDate": moment(value[1]).format(dateInsertionFormat) }))
        setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(updateTimesheetFilterDates({ "startDate": format(value[0], "yyyy-MM-dd"), "endDate": format(value[1], "yyyy-MM-dd") }));
    }

    const submitFilters = () => {
        dispatch(getTimeEntryPeriodListAsync()).then((result) => {
            if (closeButtonRef.current) {
                closeButtonRef.current.click();
            }
        });
    }

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>
                    <label className="fs-7 fw-normal mb-2">
                        {/* {t('Date Range')} */}
                        {getValueFromResource('Date Range',dispatch, t)}
                        </label>
                    <div>
                        <DateRangePicker
                            onChange={handleDateRangeChange}
                            ranges={DatePickerRanges() }
                            value={[startDate, endDate]}
                            // placeholder='Please Select Date Range'
                            placeholder={displayedRange}
                            cleanable={false}
                            character={' - '}
                            format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                        ></DateRangePicker>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
                        <Select
                            value={selectedOption}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={isSearchable}
                            name="employeeList"
                            onChange={(data) =>
                                onDropDownChange(data, 3)
                            }
                            options={employeeArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isMulti
                            closeMenuOnSelect={false}
                            components={{ MultiValue }}
                            hideSelectedOptions={false}
                        />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Approval Status')} */}
                            {getValueFromResource('Approval Status',dispatch, t)}
                            </label>
                        <Select
                            value={timesheetApprovalStatusList.filter((x: any) => x.value == timesheetApprovalStatusId)}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="ApprovalStatus"
                            onChange={(data) => onDropDownChange(data, 1)}
                            options={timesheetApprovalStatusList}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Timesheet Entered')} */}
                            {getValueFromResource('Timesheet Entered',dispatch, t)}
                            </label>
                        <Select
                            value={timesheetEnteredList.filter((x: any) => x.value == timesheetEnteredTypeId)}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="TimesheetEntered"
                            onChange={(data) => onDropDownChange(data, 2)}
                            options={timesheetEnteredList}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range',dispatch, t)}
                            </label>
                        <div className="form-check form-switch">
                            <input
                                type="checkbox"
                                className="form-check-input custom-padding-right"
                                checked={includeDateRangePeriodList}
                                onChange={(e) => { handleIncludeDateRange(e) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}
                    </button>
                    <a className={"btn btn-primary btn-sm"} onClick={() => submitFilters()}>
                        <i className="bi bi-filter fs-5 me-1"></i>
                        {/* {t('Apply Filters')} */}
                        {getValueFromResource('Apply Filters',dispatch, t)}
                    </a>
                </div>
            </div>
        </>
    )
}
const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
};
const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};

export default TimesheetPeriodFilters